import * as prismic from "@prismicio/client";

// -- Prismic API endpoint
const apiEndpoint = "https://ohio-squeeze.cdn.prismic.io/api/v2";
// -- Access Token if the repository is not public
const accessToken =
  "MC5hSUtFeXhFQUFDQUF5MU12.77-977-9MDMS77-977-977-9CO-_vTACOO-_vX0u77-977-9eXNbV--_vVTvv71kC--_vTLvv70KLw";
// -- Prismic Client
const PrismicClient = prismic.createClient(apiEndpoint, { accessToken });

export default PrismicClient;
